import { apiClient } from '../../../v4/core/apiClient';
import { createShortlistApi } from './shortlist.api.http';
import { myMetastructureMappingService } from 'v5/services/internal/MetastructureMappingService/MetastructureMappingService.connected';

export const myShortlistApi = createShortlistApi({
  client: apiClient,
  services: { metastructureMappingService: myMetastructureMappingService }
});

